<template>
    <div class="navbar navbar-dark bg-dark justify-content-center" v-if="(dataType.isLocation || dataType.isPackets || dataType.isWx || dataType.isAltitude )">
        <div class="d-flex justify-content-center flex-wrap text-center">
            <div v-if="dataType.isLocation" class="p-2"><button type="button" class="btn btn-outline-light"
                    @click="emits('emitMapBtn')">{{ t('Map') }}</button></div>
            <div v-if="dataType.isPackets" class="p-2"><button type="button" class="btn btn-outline-light"
                    @click="emits('emitPacketsBtn')">{{ t('Packets') }}</button></div>
            <div v-if="dataType.isWx" class="p-2"><button type="button" class="btn btn-outline-light"
                    @click="emits('emitWXBtn')">{{ t('WX') }}</button></div>
            <div v-if="dataType.isAltitude" class="p-2"><button type="button" class="btn btn-outline-light"
                    @click="emits('emitAltitudeBtn')">{{ t('Altitude') }}</button></div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';
import { getClearData } from '../js/fetchdata.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const emits = defineEmits(['emitMapBtn', 'emitPacketsBtn', 'emitWXBtn', 'emitAltitudeBtn'])

// const visible = ref(false)
const dataType = ref(getClearData().dataType)

defineExpose({
  dataType
});


</script>

<style scoped>

.alert-aprs {
    background-color:#6c0100;
    /* border-color:#f00;
    color:#ffcc1a; */
  }

.btn-aprs {
  background-color:#ffcc1a;
  color:#6c0100;
}

</style>

<i18n>
    {
      "pl": {
        "Map": "Mapa",
        "Packets": "Pakiety",
        "WX": "WX",
        "Altitude": "Wysokość",
      }
    }
</i18n>
